import {h, Fragment} from "preact"
import { useSizeOptions } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"
import Pagination from "./Pagination"
import Select from "./elements/Select"

export default function BottomToolbar() {
    const { from, to, size, total, handleSizeChange, sizeOptions } = useSizeOptions(sizes, defaultConfig.serpSize)
    const options = sizeOptions.map(v => ({ value: v, label: `${v} items per page` }))

    const settings = window.plpSettings || {};

    return (
        <div class="nosto-bottom-toolbar">
            <div class="breadcrumbs">
                <a href="/">home</a> | <span>{settings.title}</span>
            </div>
            <Pagination />
            <div class="total-count">
                {from} - {total < to ? total : to} of <span>{total} products</span>
            </div>
        </div>
    )
}
